import { render, staticRenderFns } from "./PasswordPhone.vue?vue&type=template&id=be31fcde"
import script from "./PasswordPhone.vue?vue&type=script&lang=ts"
export * from "./PasswordPhone.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports